var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 45",
    height: 45,
    viewBox: "0 0 50 45",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.559 38.381.006.002-2.415 4.182c-.882 1.527-2.834 2.051-4.36 1.168-1.527-.881-2.05-2.834-1.168-4.359l1.778-3.083.171-.295c.305-.439 1.057-1.195 2.562-1.053 0 0 3.542.385 3.798 2.225 0 0 .035.605-.372 1.213zm34.249-10.684h-7.53c-.512-.035-.736-.217-.824-.324l-.006-.01-8.061-13.961-.01.007-.484-.693c-.792-1.211-2.05 1.887-2.05 1.887-1.502 3.453.213 7.379.812 8.564l11.195 19.394c.882 1.525 2.834 2.049 4.36 1.168s2.05-2.834 1.169-4.361l-2.8-4.848c-.055-.117-.149-.438.425-.438h3.804c1.764 0 3.192-1.43 3.192-3.193 0-1.762-1.429-3.192-3.192-3.192zm-14.626 4.34s.402 2.045-1.152 2.045h-1.556-26.282c-1.763 0-3.192-1.43-3.192-3.193 0-1.762 1.429-3.191 3.192-3.191h7.157c1.155-.066 1.429-.734 1.429-.734l.006.004 9.342-16.18-.003-.001c.17-.312.028-.608.004-.654l-3.085-5.344c-.882-1.526-.358-3.479 1.168-4.36 1.527-.881 3.479-.358 4.36 1.168l1.431 2.478 1.428-2.474c.881-1.527 2.834-2.05 4.36-1.168s2.05 2.833 1.168 4.36l-12.998 22.514c-.057.137-.074.354.349.391h7.771l.002.076c-.001-.001 4.489.07 5.101 4.263z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.cb45d276c21cfd1f398877e6a85d9408.svg";
export { ForwardRef as ReactComponent };